import request from '@/common/request'
/** 
 *  create 增
 *  delete 删
 *  update 改
 *  query  查
*/
export default {
  createExceptionDeclare: (dynaSeg, data, params) => {
    return request({
      url: '/exceptionDeclare',
      method: 'post',
      data,
      params
    })
  },
  deleteExceptionDeclare: (dynaSeg, data, params) => {
    return request({
      url: `/exceptionDeclare/${dynaSeg.id}`,
      method: 'delete',
      data,
      params
    })
  },
  updateExceptionDeclare: (dynaSeg, data, params) => {
    return request({
      url: `/exceptionDeclare/${dynaSeg.id}`,
      method: 'put',
      data,
      params
    })
  },
  queryExceptionDeclare: params => {
    return request({
      url: '/exceptionDeclare',
      method: 'get',
      params
    })
  },
  exceptionDeclareSubmitAudit: dynaSeg => {
    return request({
      url: `/exceptionDeclare/submit/${dynaSeg.id}`,
      method: 'post'
    })
  },
  getExceptionDeclareAuditDetail: data=> {
    return request({
      url: `/exceptionDeclare/getAuditDetail`,
      method: 'post',
      data
    })
  },
  exceptionDeclareAudit:data =>{
    return request({
      url: '/exceptionDeclare/audit',
      method: 'post',
      data
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/modules/exceptionDeclare.js